<template>
  <div>
    <div class="row evollu-form">
      <!--Created At Filter --->
      <div class="col-12 col-md-4">
        <label class="form-label">{{ $t('statistics.daterange_created_at') }}</label>
        <RangeDatePicker
          id="date-filter-picker"
          v-model="filters.date"
          class="col-12 datesFilter"
          :placeholder="$t('optometry.leads.date_range')"/>
      </div>
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{$t('facility.inputs.entity')}}:</label>
          <multiselect
            v-model="filters.entities"
            :options="authorizedEntities.length === 1 ? authorizedEntities[0] : authorizedEntities"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            select-label=""
            selected-label=""
            deselect-label=""
            :placeholder="$t('facility.inputs.entity')"
            :allow-empty="true"
            :multiple="true"
            :searchable="true"
            :disabled="authorizedEntities.length === 1">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entities"
                      @mousedown.prevent.stop="clearEntitiesMultiselect"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <v-server-table
      id="biosignalsLeadsTable"
      ref="biosignalsLeadsTable"
      name="biosignalsLeadsTable"
      :columns="columns"
      :options="tableOptions"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleLeadClicked"
      @filter="onFilterUpdate"
    >
      <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="name" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.name ? props.row.person.name : "N/A" : "N/A"}}</span>
      <span slot="email" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.email ? props.row.person.email : "N/A" : "N/A"}}</span>
      <span slot="mobilePhone" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.mobilePhone ? props.row.person.mobilePhone : "N/A" : "N/A"}}</span>
      <span slot="entity" class="no-break" slot-scope="props"> {{handleEntityName(props.row)}}</span>
      <span v-for="param in healthParams" :slot="param.name" class="no-break" slot-scope="props"> {{extractValue(props.row, param)}}</span>


    </v-server-table>
  </div>
</template>

<script>
 import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
 import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
 import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
 import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
 import { EvohealthService } from '@/api/EvohealthService';
 import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
 import Multiselect from 'vue-multiselect';
 import LocalStorageHelper from '@/local-storage/LocalStorageHelper';
 import { TABLE_BIOSIGNS_LEADS } from '@/local-storage/LocalStorageKeys';

 export default {
   components: { Multiselect, RangeDatePicker },
   props: {
     healthParams: {
       type: Array,
       required: true,
     }
   },
   mixins: [
     IsFromEvolluMixin,
     TableQueryMixin,
     MultiselectLabelFormatter,
     ClustersAndEntitiesMixin
   ],
   data () {
     return {
       entitiesOptions: [],
       filters: {
         entities: null,
         facility: null,
         date: {
           start: '',
           end: '',
         }
       },
       queryUrl: `${this.$store.state.evohealth_server}v1/leads/1/all`,
       columns: ['createdAt', 'name', 'email', 'mobilePhone', 'entity', 'heartRate','heartRateVariability','systolicBloodPressure','diastolicBloodPressure','respiratoryRate','oxygenSaturation','stressIndex'],
       tableOptions: {
         orderBy: {
           column: 'createdAt',
           ascending: false
         },
         saveState: true,
         storage: 'local',
         filterable: true,
         sortable: ['createdAt'],
         customFilters: ['start', 'end', 'entities'],
         headings: {
           createdAt: this.$t('leads.table.created_at'),
           name: this.$t('biosigns.columns.name'),
           email: this.$t('biosigns.columns.email'),
           mobilePhone: this.$t('biosigns.columns.mobilePhone'),
           entity: this.$t('biosigns.columns.entity'),
           hearthRate: this.$t('biosigns.columns.hearthRate'),
           hearthRateVariability: this.$t('biosigns.columns.hearthRateVariability'),
           systolicBloodPressure: this.$t('biosigns.columns.systolicBloodPressure'),
           diastolicBloodPressure: this.$t('biosigns.columns.diastolicBloodPressure'),
           respiratoryRate: this.$t('biosigns.columns.respiratoryRate'),
           oxygenSaturation: this.$t('biosigns.columns.oxygenSaturation'),
           stressIndex: this.$t('biosigns.columns.stressIndex'),
           ansIndexPns: this.$t('biosigns.columns.ansIndexPns'),
           ansIndexSns: this.$t('biosigns.columns.ansIndexSns')
         },
         columnsClasses: {
           createdAt: 'created_at',
         }
       }
     }
   },
   async mounted() {
     //const healthParamsNames = this.healthParams.map(param => param.name)
     //this.columns.push(...healthParamsNames)
     this.loadLocalStorage()
   },
   methods: {
     clearEntitiesMultiselect: function () {
       this.filters.entities = null
       this.emitTableFilter(`vue-tables.biosignalsLeadsTable.filter::entities`, '')
     },
     reload: function () {
       this.$refs.biosignsLeadsTable.refresh()
     },
     onLoading: function () {
       this.$emit('loading')
     },
     onLoaded: function (state) {
       this.$emit('loaded', state)
     },
     handleLeadClicked: function ({ row }) {
       let selectedLead = row
       this.$emit('leadClicked', selectedLead)
     },
     handleEntityName: function (lead) {
       if(lead.entityId !== null) {
         const entity = this.authorizedEntities.find(entity => entity.id === lead.entityId)
         if(entity) {
           lead.entity = entity
           return entity.name
         }
       }

       return "N/A"
     },
     extractValue: function (lead, healthParam) {
       if(lead.values === null || lead.values.length === 0) {
         return "N/A"
       }
       const leadValues = lead.values.flatMap(val => val.leadValues)
       const leadValue = leadValues.find(val => val.healthParam.id === healthParam.id)
       if(leadValue && leadValue.value !== '' && leadValue.value !== null && leadValue.value !== undefined) {
         let valueText = leadValue.value
         if(healthParam.unit) valueText += ` ${healthParam.unit}`
         return valueText
       }

       return "N/A"
     },
     loadLocalStorage: function () {
       let state = LocalStorageHelper.get(TABLE_BIOSIGNS_LEADS)
       if (state) {
         if (Object.values(state.customQueries).some(object => object !== '')) {
           this.showFilters = true

           if (state.customQueries.entities && state.customQueries.entities !== '') {
             const entIds = state.customQueries.entities.split(',').map(id => parseInt(id))
             this.filters.entities = this.authorizedEntities.filter(entities => entIds.includes(parseInt(entities.id)) )
           }


           if (state.customQueries.start !== '' && state.customQueries.end !== '') {
             this.filters.date.start = state.customQueries.start
             this.filters.date.end = state.customQueries.end
           }
         }
       }
     },
   },
   computed: {
     authorizedEntities: function () {
       let evohealthService = this.$store.state.services.find(service => service.url === this.$store.state.evohealth_server) || null
       if (evohealthService) {
         if (evohealthService.user_permissions.some(p => p.entity_id === null)) {
           return evohealthService.entities
         } else {
           return evohealthService.entities.filter(entity => evohealthService.user_permissions.filter(p => p.entity_id === entity.id))
         }
       }
       return []
     },
   },
   watch: {
     'filters.date': function (value) {
       this.$refs['biosignalsLeadsTable'].customQueries.start = value.start || ''
       this.emitTableFilter(`vue-tables.biosignalsLeadsTable.filter::end`, value.end || '')
     },
     'filters.entities': function (value) {
       if (value) {
         const parsedIds = value.map(elem => parseInt(elem.id)).join(',')
         this.emitTableFilter(`vue-tables.biosignalsLeadsTable.filter::entities`, parsedIds || '')
       }
     },
   }
 }

</script>


<style scoped lang="scss">

</style>
